module.exports = __webpack_public_path__ + "static/media/wirebit-menu-brand.6763c1bc.svg";